import { render, staticRenderFns } from "./BeLoading.vue?vue&type=template&id=51823662&"
import script from "./BeLoading.vue?vue&type=script&lang=js&"
export * from "./BeLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports